import React from 'react';
import { Canvas } from 'react-three-fiber';
import { OrbitControls } from 'drei';
import Loading from '../../components/Loading';

import App from '../../the-gallery/components/App/App';

export default function App15(props) {

    return (
        <App />
    );
}